import React,{FC} from 'react';
import "./CustomKeyboardComp.scss";
import { PropsType } from './CustomKeyboardCompType';
import { keyboardUrl } from '../../CommonUtils/Constants';

const CustomKeyboardComp : FC <PropsType>= ({keyboardVisibility}) => {
  
  /*Pure Component */  
  return (
    <>
    <iframe
      id="customScreenKeyboard"
      title="customScreenKeyboard"
      src={keyboardUrl}
      className={`custom-keyboard ${keyboardVisibility ? "show" : ""}`}
    />
    </>
  )
}

export default React.memo(CustomKeyboardComp);
